import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { ButtonClose, ButtonEditImage } from '@design-system/button';
import { __ } from '@design-system/i18n';
import { Loader } from '@design-system/loader';
import { useRef } from 'react';
import { styled } from 'styled-components';
import { Preview } from './Preview';
export const FilePreview = ({ height = '160px', image, isLoading, name, onClick, onRemove, width = '160px', }) => {
    const editButtonRef = useRef(null);
    return (_jsxs(Box, { height: height, onMouseEnter: () => { var _a; return (_a = editButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, onMouseLeave: () => { var _a; return (_a = editButtonRef.current) === null || _a === void 0 ? void 0 : _a.blur(); }, position: "relative", width: width, children: [_jsx(Preview, { image: image, name: name, onClick: onClick, onError: onRemove }), isLoading && (_jsx(LoaderWrapper, { color: "white", children: _jsx(Loader, { size: 48, strokeWidth: 4 }) })), _jsx(ClearButtonWrapper, { children: onRemove ? (_jsx(ButtonClose, { "aria-label": __('Remove image'), onClick: onRemove, variant: "inversed" })) : onClick ? (_jsx(ButtonEditImage, { "aria-label": __('Change image'), onClick: onClick, ref: editButtonRef, variant: "inversed" })) : null })] }));
};
const LoaderWrapper = styled(Box) `
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
`;
const ClearButtonWrapper = styled(Box) `
  position: absolute;
  top: ${(props) => props.theme.space[2]}px;
  right: ${(props) => props.theme.space[2]}px;
  z-index: 1;
`;
//# sourceMappingURL=FilePreview.js.map